import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NameValue, ModalResult, ModalAnswer } from '../../../shared/models/shared.model';
import { Meeting, Dealer } from '../../model/distributor.model';
import { AdaService } from '../../../shared/services/ada.service';

@Component({
  selector: 'app-dealer-list',
  templateUrl: './dealer-list.component.html',
  styleUrls: ['./dealer-list.component.scss']
})
export class DealerListComponent implements OnInit {

  @Input() states: Array<NameValue> = [];
  @Input() countries: Array<NameValue> = [];
  @Input() dealers: Array<Dealer> = [];
  @Output() onAddNewDealer: EventEmitter<Dealer> = new EventEmitter<Dealer>();
  @Output() onMeetingRequest: EventEmitter<Meeting> = new EventEmitter<Meeting>();
  dealer: Dealer = new Dealer({
    name: '', //  'A New Dealer',
    email: '', // 'fred@smith.com',
    phone: '', // '555-111-2223',
    phoneExt: '', // '1234',
    contact: {
      fullName:'', // 'Julie Johnson',
      email: '', // 'jjohnson@gmail.com',
      phone: '', // '555-111-2222'
    },
    addressLine1: '', // '123 Main Street',
    city: '', // 'Atlanta',
    state: '', // 'GA',
    zip: '', // '30774',
    country: 'US'
  });

  sponsorDealerPopupVisible: boolean = false;
  requestMeetingPopupVisible: boolean = false;

  constructor(private _adaService: AdaService) { }

  ngOnInit() {
  }

  newDealer() {
    this.sponsorDealerPopupVisible = true;
  }

  requestMeeting() {
    this.requestMeetingPopupVisible = true;
  }

  whenModalClose(modalResult: ModalResult) {
    if (modalResult.answer == ModalAnswer.OK) {
      this.onAddNewDealer.emit(modalResult.data);
    }
    this.sponsorDealerPopupVisible = false;
  }

  whenRequestMeetingClose(modalResult: ModalResult) {
    if (modalResult.answer == ModalAnswer.OK) {
      this.onMeetingRequest.emit(modalResult.data);
    }
    this.requestMeetingPopupVisible = false;
  }

  get adaService() {
    return this._adaService;
  }
}



// WEBPACK FOOTER //
// ./src/app/distributor/components/dealer-list/dealer-list.component.ts